import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'
import { purgeLegacyServiceWorker } from './bootstrap/purgeLegacyServiceWorker'

// Fuentes self-hosted (c91) — antes del design system para que los @font-face
// queden registrados primero; reemplaza el <link> de Google Fonts (css2 servía
// archivos 404 según el stack HTTP del navegador).
import './assets/fonts.css'

// Design system (single source): provided by @numera/ui
import '@numera/ui/dist/style.css'

// iOS auto-zoom: controles < 16px en táctil (c239) — DEBE ir después del
// design system para ganar la cascada.
import './assets/mobile-forms.css'

// Hoja imprimible (c753) — libera el shell de altura fija y deja el alto
// natural al papel. DEBE ir después del design system, que trae las reglas
// `@media print` (.print-hidden, .btn, .card, #app) que este archivo completa.
import './assets/print.css'

// Performance features
import { performancePlugin } from './services/performance/performanceMonitor'
import { performanceConfig } from './config/performance'

const app = createApp(App)

// Drop stale SW caches from older builds (causes lazy-route chunk 404 / blank pages).
void purgeLegacyServiceWorker()

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)

// Initialize Performance Plugin
if (performanceConfig.monitoring.enabled) {
  app.use(performancePlugin)
}

// Register Service Worker for offline support and caching
if (performanceConfig.serviceWorker.enabled && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('ServiceWorker registration successful:', registration)
      })
      .catch(err => {
        console.log('ServiceWorker registration failed:', err)
      })
  })
}

// Enable Vue.js devtools in development
if (import.meta.env.DEV) {
  app.config.performance = true
}

app.mount('#app')
